var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"absolute":_vm.absolute,"temporary":_vm.temporary,"stateless":_vm.stateless,"value":_vm.value},on:{"input":_vm.onInput}},[_c('v-list',[_c('menu-element',{attrs:{"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }